import { useEffect, useState } from 'react';
export const useWindow = () => {
    const [myWindow, setMyWindow] = useState(null);
    useEffect(() => {
        setMyWindow(window);
    }, []);
    return myWindow;
};
